export const groupManagement = {
  apply: 'APPLY',
  cancel: 'CANCEL',
  choose_your_community_groups: 'Choose Your Community Groups',
  manage_community_groups: 'Manage Community Groups',
  manage_details: 'Select the groups that feel right for you from the options below.',
  manage_my_groups: 'Manage My Groups',
  onboarding_details: "<strong>Thank you!</strong> Before you begin, choose any groups you'd like to join. You can update your selections anytime by visiting <strong>Manage My Groups</strong> in the PrayerStream sidebar",
  skip_for_now: 'SKIP FOR NOW',
} as const;

export type GroupManagementNamespace = Record<keyof typeof groupManagement, string>;
